import Link from "next/link";
import { Button, Card } from "@chef/components";
import { BRAND_PATHS } from "@chef/constants";

import {
  formatDate,
  getWeek,
  getYear,
  isMealboxBasketType,
  nextDeliveryWeekDateObj,
} from "@chef/helpers";
import { Success } from "@chef/icons/symbol";
import { useBillingQuery, useCalendarQuery } from "@chef/state-management";
import {
  getBasketDataFromCalendar,
  getNextDeliveryFromCalendar,
  getWeeklyTimeblockDataFromCalendar,
} from "@chef/state-management/helpers";
import { PageLoader } from "@chef/smart-components";
import { AppShell } from "@chef/feature-app-shell";
import { intl } from "./SuccessReactivationPage.Intl";
export const SuccessReactivationPage = () => {
  const nextDeliveryDate = nextDeliveryWeekDateObj();
  const nextWeek = getWeek(nextDeliveryDate);
  const nextYear = getYear(nextDeliveryDate);

  const { data: billingQuery, isLoading: isBillingLoading } = useBillingQuery();

  const { data: calendarQuery, isLoading: isCalendarLoading } =
    useCalendarQuery({
      week: nextWeek,
      year: nextYear,
      range: 4,
    });

  const calendar = calendarQuery?.calendar;

  const isLoading = isBillingLoading || isCalendarLoading || !calendar;

  if (isLoading) {
    return <PageLoader />;
  }

  const defaultBasket = billingQuery?.billing.baskets.find(isMealboxBasketType);

  const nextCalendar = getNextDeliveryFromCalendar({ calendar });

  const timeblock =
    !!nextCalendar &&
    getWeeklyTimeblockDataFromCalendar({
      calendar,
      week: nextCalendar?.week,
      year: nextCalendar?.year,
    });

  const basketData = getBasketDataFromCalendar({
    calendar,
    week: nextWeek,
    year: nextYear,
  });

  const deliveryDate =
    basketData?.mealboxBasket?.shippingDetails.plannedDeliveryInformation
      .deliveryDate;

  const deliveryDateString =
    !!deliveryDate && formatDate(new Date(deliveryDate), "yyyy-MM-dd");

  return (
    <AppShell title={intl.REACTIVATION}>
      <AppShell.Meta />
      <AppShell.AccountPausedBanner />
      <AppShell.OldVippsBanner />

      <AppShell.Main className="flex items-center justify-center">
        <Card className="max-w-xl text-center">
          <div className="md:mx-16">
            <div className="mt-16">
              <Success className="w-20 h-20" />
            </div>

            <h1 className="mt-6 text-xl break-words md:text-2xl">
              {intl.YOUR_DELIVERY_HAS_STARTED}
            </h1>

            {!!timeblock && (
              <>
                <div className="p-4 mt-4 text-center">
                  <p className="text-sm">{intl.YOUR_FIRST_DELIVERY_ARRIVES}</p>
                </div>
                <div className="py-4 mt-3 bg-informationBG ">
                  <p className="text-lg">
                    <strong>{deliveryDateString}</strong>
                  </p>
                </div>
              </>
            )}

            <div className="mt-2 text-sm">
              <strong>
                {defaultBasket &&
                  intl.YOUR_MEALBOX_GETS_DELIVERED(
                    defaultBasket?.deliveryInterval,
                  )}
              </strong>
            </div>

            <div className="mb-8 text-sm">
              {intl.CHANGE_DELIVERY_INTERVAL_INFO}
            </div>

            <Link href={BRAND_PATHS.MY_MENU_PAGE} passHref legacyBehavior>
              <div className="mb-16">
                <Button primary className="md:w-72" full>
                  {intl.SEE_MY_MENU}
                </Button>
              </div>
            </Link>
          </div>
        </Card>
      </AppShell.Main>
      <AppShell.TabBar />
    </AppShell>
  );
};
